/**
 * Decorative "fresh board" hero visual (#103) — a stylized Peril board that shows, at a
 * glance, what the product is (a generated grid of categories + dollar values). Purely
 * presentational and static, so it prerenders cleanly (FR-15.2) and never touches the
 * live game. Marked `aria-hidden` — it's illustrative chrome, not content a screen reader
 * needs to enumerate; the hero copy carries the meaning.
 */

const CATEGORIES = ["'90s Film", 'Capitals', 'Science', 'Sports', 'Memes'];
const VALUES = [200, 400, 600];

export function BoardVisual(): React.JSX.Element {
  return (
    <div className="landing-visual" data-testid="landing-board-visual">
      <div className="landing-board" aria-hidden="true">
        {CATEGORIES.map((c) => (
          <div key={c} className="landing-board__cat">
            {c}
          </div>
        ))}
        {VALUES.map((v) =>
          CATEGORIES.map((c) => (
            <div key={`${c}-${v}`} className="landing-board__cell">
              {v}
            </div>
          )),
        )}
      </div>
      <p className="landing-visual__cap">A fresh board, generated for your table</p>
    </div>
  );
}
